import { formatMoney } from "@/features/worksheets/money";

type Rec = Record<string, unknown>;

/** Read a string field off a raw snake_case record. */
export function str(row: Rec, key: string): string {
  const v = row[key];
  return v == null ? "" : String(v);
}

/** Read a number field (or null) off a raw record. */
export function num(row: Rec, key: string): number | null {
  const v = row[key];
  if (v == null || v === "") return null;
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
}

/** Read a boolean field off a raw record. */
export function bool(row: Rec, key: string): boolean {
  return Boolean(row[key]);
}

/** Display a cents money field, falling back to a dash when empty. */
export function money(row: Rec, key: string): string {
  const v = num(row, key);
  return v == null ? "—" : formatMoney(v);
}

/** Display a *decimal-dollar* money field (clients-app serializers use plain
 * DecimalField — dollars, not cents — e.g. employer wages, pay-stub amounts). */
export function moneyDecimal(row: Rec, key: string): string {
  const v = num(row, key);
  return v == null ? "—" : formatMoney(Math.round(v * 100));
}

/** Non-empty string or an em dash. */
export function dash(value: string): string {
  return value === "" ? "—" : value;
}
